import { FormControl } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Question } from "@/types/question";
import { forwardRef } from "react";
import { ControllerRenderProps, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface DependableQuestionSelectProps extends ControllerRenderProps {
  options: Question[];
}

const DependableQuestionSelect = forwardRef<
  HTMLButtonElement,
  DependableQuestionSelectProps
>(({ options, onChange, value }, ref) => {
  const { t } = useTranslation();
  const { isSubmitting, disabled } = useFormState();

  return (
    <Select
      onValueChange={onChange}
      defaultValue={value}
      disabled={isSubmitting || disabled}
    >
      <FormControl>
        <SelectTrigger ref={ref}>
          <SelectValue placeholder={t("dependentQuestions.noSelection")} />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {options.map((question, index) => {
          return (
            <SelectItem key={question.id} value={question.id.toString()}>
              {question.question
                ? question.question
                : t("dependentQuestions.untitledQuestion", {
                    number: index + 1,
                  })}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
});

export default DependableQuestionSelect;
